import axios from 'axios'
import Api from '@/api/api'
import ConfigApi from '@/api/config/_api_config'

// Une instance par timeline ; ses capacités et requêtes disparaissent avec l'écran.
export function createPatientTimelineApi(identity) {
    let capability = null, capabilityPromise = null, epoch = 0
    const sources = new Set()
    function invalidate() {
        epoch++; capability = null; capabilityPromise = null
        sources.forEach(source => source.cancel('Contexte du dossier modifié'))
        sources.clear()
    }
    function check(ticket, actor) {
        const now = identity()
        if (ticket !== epoch || !now || now.key !== actor.key) {
            const error = new Error('Contexte du dossier modifié'); error.__CANCEL__ = true; throw error
        }
    }
    async function access(ticket, actor, source) {
        if (capability && capability.key === actor.key && capability.until > Date.now()) return capability.token
        if (!capabilityPromise) {
            const request = ConfigApi().post('/patients/history-access', {}, {
                patient_history_scoped: true, timeout: 20000, cancelToken: source.token
            }).then(response => {
                check(ticket, actor)
                const body = response && response.data, data = body && body.data
                if (!body || body.success !== true || !data || typeof data.access_token !== 'string' || !data.access_token
                    || Number(data.actor_id) !== Number(actor.id) || !(Number(data.expires_in) > 0)) throw new Error('Autorisation indisponible')
                capability = { key: actor.key, token: data.access_token, until: Date.now() + Math.max(0, Number(data.expires_in) - 20) * 1000 }
                return capability.token
            }).finally(() => { if (ticket === epoch) capabilityPromise = null })
            capabilityPromise = request
        }
        return capabilityPromise
    }
    async function get(url, params) {
        const actor = identity(), ticket = epoch, source = axios.CancelToken.source()
        if (!actor || !actor.id) throw new Error('Session indisponible')
        sources.add(source)
        try {
            for (let attempt = 0; attempt < 2; attempt++) {
                const token = await access(ticket, actor, source)
                check(ticket, actor)
                try {
                    const response = await Api().get(url, { params, med_access_scoped: true, timeout: 20000,
                        cancelToken: source.token, headers: { 'X-Patient-History-Access': token } })
                    check(ticket, actor)
                    return response.data
                } catch (error) {
                    check(ticket, actor)
                    if (attempt === 0 && error.response && error.response.status === 401) {
                        if (capability && capability.token === token) capability = null
                        continue
                    }
                    if (error.response && [401, 403, 404].includes(Number(error.response.status))) capability = null
                    throw error
                }
            }
        } finally { sources.delete(source) }
    }
    const prefix = patient => '/patients/' + Number(patient) + '/consultations'
    return {
        invalidate,
        list: (patient, params) => get(prefix(patient) + '/timeline', params),
        details: (patient, consultation) => get(prefix(patient) + '/' + Number(consultation) + '/timeline-details'),
        artifacts(patient, consultation, type) {
            if (!['prescription', 'certificate', 'opinion'].includes(type)) return Promise.reject(new Error('Type de document invalide'))
            return get(prefix(patient) + '/' + Number(consultation) + '/timeline-artifacts/' + type)
        }
    }
}
